import { ReducerActionRotaSP } from 'store/modules/types';

import { Types, IncluirIntencaoVendaRequest } from './types';

export function incluirIntencaoVendaRequest(
	token: string,
	data: IncluirIntencaoVendaRequest,
): ReducerActionRotaSP {
	return {
		type: Types.INCLUIR_INTENCAO_VENDA_REQUEST,
		token,
		payload: data,
	};
}

export function incluirIntencaoVendaSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.INCLUIR_INTENCAO_VENDA_SUCCESS,
		payload,
	};
}

export function incluirIntencaoVendaFailure(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.INCLUIR_INTENCAO_VENDA_FAILURE,
		payload,
	};
}

export function incluirIntencaoVendaClear(): ReducerActionRotaSP {
	return {
		type: Types.INCLUIR_INTENCAO_VENDA_CLEAR,
		payload: null,
	};
}
